export default "__VITE_ASSET__UDel0oCR__"